"use client";

import { createContext, useContext, useEffect } from "react";
import type { Locale } from "@/lib/i18n";
import { localeToLanguageTag } from "@/lib/i18n";

const LocaleContext = createContext<Locale>("de");

export function LocaleProvider({
  locale,
  children,
}: {
  locale: Locale;
  children: React.ReactNode;
}) {
  useEffect(() => {
    document.documentElement.lang = localeToLanguageTag(locale);
    document.documentElement.dataset.locale = locale;
  }, [locale]);

  return (
    <LocaleContext.Provider value={locale}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  return useContext(LocaleContext);
}
